import React, { useRef } from 'react';
import { useInView } from 'react-intersection-observer';

import './style.css';

export const Timeline = () => {
  const { ref: timelineRef, inView: isVisible } = useInView();
  console.log(isVisible);
  return (
    <div className='wrapper-timeline'>
      <span className='timeline-heading'>
        {' '}
        <span className='timeline-heading-color'>Milestones</span> of your
        Child’s Space Journey
      </span>
      <div
        className='timeline'
        ref={timelineRef}
        style={{ opacity: isVisible ? 1 : 0 }}
      >
        <span className='timeline-start'>Start</span>
        <div className='big-card'>
          <div
            className='card'
            style={{
              marginRight: '40%',
              animation: isVisible ? 'card-opacity 1s ease-in-out' : '',
            }}
          >
            <div className='pic'>
              <div
                className='pic-logo'
                style={{
                  background: `url(${require('../../assets/board.png')})`,
                  backgroundSize: 'contain',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                }}
              ></div>
              <div className='pic-desc'>
                <span className='label-heading'>Introduction</span>
                <span className='label-text'>Space Science Topics</span>
              </div>
            </div>{' '}
            <div
              className='line'
              style={{
                animation: isVisible ? 'line-height 1s ease-in-out' : '',
              }}
            ></div>
          </div>
          <div
            className='hr-line'
            style={{ animation: isVisible ? 'hr-link 1s ease-in-out' : '' }}
          ></div>
          <div
            className='card'
            style={{
              flexDirection: 'column-reverse',
              marginLeft: '40%',
              animation: isVisible ? 'card-opacity 1s ease-in-out' : '',
            }}
          >
            <div className='pic' style={{ background: '#D2FFD1' }}>
              <div className='pic-logo'></div>
              <div className='pic-desc'>
                <span className='label-heading'>Certificate</span>
                <span className='label-text'>Junior Space Explorer</span>
              </div>
            </div>
            <div
              className='line'
              style={{
                animation: isVisible ? 'line-height 1s ease-in-out' : '',
              }}
            ></div>
          </div>
        </div>
        <div className='month'>
          <span className='month-date'>01</span>
          <span className='month-label'>Month</span>
        </div>{' '}
        <div className='big-card' style={{ height: '70%' }}>
          <div
            className='card'
            style={{
              marginRight: '40%',
              animation: isVisible ? 'card-opacity 1s ease-in-out' : '',
            }}
          >
            <div
              className='pic'
              style={{ height: '35%', background: '#D8D1FF' }}
            >
              <div
                className='pic-logo'
                style={{
                  background: `url(${require('../../assets/office.png')})`,
                  backgroundSize: 'contain',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                }}
              ></div>
              <div className='pic-desc'>
                <span className='label-heading'>Project</span>
                <span className='label-text'>Space Body/Vehicles</span>
              </div>
            </div>
            <div
              className='line'
              style={{
                height: '65%',
                animation: isVisible ? 'line-height-small 1s ease-in-out' : '',
              }}
            ></div>
          </div>
          <div
            className='hr-line'
            style={{ animation: isVisible ? 'hr-link 1s ease-in-out' : '' }}
          ></div>
          <div
            className='card'
            style={{
              flexDirection: 'column-reverse',
              marginLeft: '40%',
              animation: isVisible ? 'card-opacity 1s ease-in-out' : '',
            }}
          >
            <div className='pic' style={{ height: '35%' }}>
              <div
                className='pic-logo'
                style={{
                  background: `url(${require('../../assets/certinew.png')})`,
                  backgroundSize: 'contain',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                }}
              ></div>
              <div className='pic-desc'>
                <span className='label-heading'>Certificate</span>
                <span className='label-text'>Young Space Creator</span>
              </div>
            </div>{' '}
            <div
              className='line'
              style={{
                height: '65%',
                animation: isVisible ? 'line-height-small 1s ease-in-out' : '',
              }}
            ></div>
          </div>
        </div>
        <div className='month'>
          <span className='month-date'>03</span>
          <span className='month-label'>Months</span>
        </div>{' '}
        <div className='big-card'>
          <div
            className='card'
            style={{
              marginRight: '40%',
              animation: isVisible ? 'card-opacity 1s ease-in-out' : '',
            }}
          >
            <div className='pic' style={{ background: '#D2FFD1' }}>
              <div
                className='pic-logo'
                style={{
                  background: `url(${require('../../assets/work.png')})`,
                  backgroundSize: 'contain',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                }}
              ></div>
              <div className='pic-desc'>
                <span className='label-heading'>Internship</span>
                <span className='label-text'>Space Research Institute</span>
              </div>
            </div>{' '}
            <div
              className='line'
              style={{
                animation: isVisible ? 'line-height 1s ease-in-out' : '',
              }}
            ></div>
          </div>
          <div
            className='hr-line'
            style={{ animation: isVisible ? 'hr-link 1s ease-in-out' : '' }}
          ></div>
          <div
            className='card'
            style={{
              flexDirection: 'column-reverse',
              marginLeft: '40%',
              animation: isVisible ? 'card-opacity 1s ease-in-out' : '',
            }}
          >
            <div className='pic' style={{ background: '#D8D1FF' }}>
              <div
                className='pic-logo'
                style={{
                  background: `url(${require('../../assets/diploma.png')})`,
                  backgroundSize: 'contain',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                }}
              ></div>
              <div className='pic-desc'>
                <span className='label-heading'>Certificate</span>
                <span className='label-text'>Visionary Space Kid</span>
              </div>
            </div>{' '}
            <div
              className='line'
              style={{
                animation: isVisible ? 'line-height 1s ease-in-out' : '',
              }}
            ></div>
          </div>
        </div>
        <div className='month'>
          <span className='month-date'>06</span>
          <span className='month-label'>Months</span>
        </div>
      </div>
      <div className='timeline-mob'>
        <div className='timeline-mob-pic'></div>
      </div>
    </div>
  );
};
